import { AppConfigStateModel } from '../app/model';

declare const require: any;

export const environment: AppConfigStateModel = {
  production: false,
  auth: null,
  baseApiUrl: '',
  environment: '',
  authorizationTokensUrl: '',
  errorHandlerConfig: null,
  contactDetails: {
    slackChannelLink: '',
    dicAdminEmail: '',
  },
  version: require('../../package.json').version
};
